export default {
  "inviteBoxAdmin.title": "代理返现管理",
  "inviteBoxAdmin.thead.index": "#No",
  "inviteBoxAdmin.thead.id": "ID",
  "inviteBoxAdmin.thead.inviteUserNum": "邀请用户数",
  "inviteBoxAdmin.thead.bonus": "奖励",
  "inviteBoxAdmin.thead.withdrawLimitRatio": "流水倍率",
  "inviteBoxAdmin.thead.createTime": "创建时间",
  "inviteBoxAdmin.thead.modifyTime": "修改时间",
  "inviteBoxAdmin.thead.operator": "操作人",

  "inviteBoxAdmin.thead.action": "操作",
  "inviteBoxAdmin.add": "新增",
  "inviteBoxAdmin.edit": "编辑",
  "inviteBoxAdmin.details": "详情",
  "inviteBoxAdmin.delete": "删除",
};
